import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import { updatePassword } from "../../services/user.service";

const ChangePasswordModal = ({ open, onClose, userId }) => {
  const initialValues = {
    newPassword: "",
    confirmPassword: "",
  };
  const dispatch = useDispatch();


  const validationSchema = Yup.object().shape({
    newPassword: Yup.string().required("New Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const handleSubmit = (values) => {
    const payload = {
      _id: userId,
      newPassword: values.newPassword,
    };
    updatePassword(payload)
      .then(() => {
        dispatch(showToast({ message: "Password changed successfully", type: "success" }));
        onClose(); // Close modal
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("email");
        localStorage.removeItem("userId");
        localStorage.removeItem("userName");
        localStorage.removeItem("role");
        localStorage.removeItem("projectId");
        localStorage.removeItem("isOverAllAdmin");
        localStorage.removeItem("isAdmin");
        window.location.href = process.env.REACT_APP_LOGOUT_URL;
      })
      .catch(() => {
        dispatch(showToast({ message: "Failed to change password", type: "success" }));
      });
  };

  return (
    <Dialog open={open} onClose={() => { }} fullWidth maxWidth="sm">
      <DialogTitle>Change Your Password</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          For security reasons, please update your password.
        </Typography>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                New Password
              </Typography>
              <Field
                // as={TextField}
                name="newPassword"
                className="InputField"
                type="password"
                fullWidth
                margin="normal"
              />
              <ErrorMessage name="newPassword" component="div" className="form-error" />


              <Typography className="inputTitle" sx={{ fontSize: "12px",marginTop:"15px" }}>
                New Password
              </Typography>
              <Field
                // as={TextField}
                name="confirmPassword"
                className="InputField"
                type="password"
                fullWidth
                margin="normal"
              />
              <ErrorMessage name="confirmPassword" component="div" className="form-error" />
              <DialogActions sx={{ justifyContent: "flex-end" }}>
                <Button type="submit" sx={{
                  mt:2,
                }} className="addButton"
                >
                  Change Password
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordModal;
